// src/components/RoleProtectedRoute.jsx
import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import LoadingSpinner from "./LoadingSpinner";
import { firstAccessiblePage } from "../utils/pageAccess";

const RoleProtectedRoute = ({ allowedRoles, children }) => {
  const { currentUser, userRole, authLoading, settingsLoading, canAccessPage, accessSettings } = useAuth();
  const { pathname } = useLocation();

  if (authLoading || (userRole && settingsLoading)) {
    return <LoadingSpinner />;
  }

  if (!userRole) {
    return <Navigate to="/login" replace />; // not logged in
  }

  if (!allowedRoles.includes(userRole)) {
    return <Navigate to="/not-authorized" replace />;
  }

  // Page switched off for this role by a superadmin — send them somewhere they can go.
  if (!canAccessPage(pathname)) {
    return <Navigate to={firstAccessiblePage(userRole, accessSettings, currentUser?.uid)} replace />;
  }

  return children;
};

export default RoleProtectedRoute;
